import React from 'react';
import './BaseModal.css';

type Props = {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
};

const BaseModal: React.FC<Props> = ({ title, onClose, children }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

export default BaseModal;
